<div class="comment__details flex gap-5">
  <div class="user__image">
    <img [src]="comment.user.picturePath" alt="user-img" />
  </div>

  <div class="comment__content flex flex-col gap-5 flex-1">
    <div class="comment__header flex justify-between">
      <h4
        class="username"
        [innerText]="comment.user.fullName || '' | ellipsis: 50"
      ></h4>
      <span
        class="comment__date"
        [title]="comment.commentedAt | date: 'medium'"
        [innerText]="comment.commentedAt | dateAgo"
      ></span>
    </div>

    <div class="comment__body">
      <p class="comment__text" [innerText]="comment.comment"></p>

      <div class="comment__interactions flex justify-end items-center gap-4">
        <div
          class="reaction flex items-center gap-1"
          (click)="like()"
          [ngClass]="{ active: comment.isLiked }"
        >
          <div inlineSVG="landing/like.svg"></div>
          <span [innerText]="comment.likeCount"></span>
        </div>
        <div
          class="reaction flex items-center gap-1"
          (click)="dislike()"
          [ngClass]="{ active: comment.isDisliked }"
        >
          <div inlineSVG="landing/dislike.svg"></div>
          <span [innerText]="comment.dislikeCount"></span>
        </div>
      </div>
    </div>
  </div>
</div>
